export default "__VITE_ASSET__a4aqzc8G__"